import mintSwipe from './Swipe'
import mintProgress from './Progress'
export default{
	mintSwipe,
	mintProgress
}


// WEBPACK FOOTER //
// ./src/components/list/mint-ui/index.js